/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Branch_Off_ErrorInputs */

const es_chat_branch_off_error = /** @type {(inputs: Chat_Branch_Off_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al crear bifurcación`)
};

const en_chat_branch_off_error = /** @type {(inputs: Chat_Branch_Off_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create branch`)
};

/**
* | output |
* | --- |
* | "Failed to create branch" |
*
* @param {Chat_Branch_Off_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_branch_off_error = /** @type {((inputs?: Chat_Branch_Off_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Branch_Off_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_branch_off_error(inputs)
	return en_chat_branch_off_error(inputs)
});
export { chat_branch_off_error as "chat.branch_off.error" }